import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
  
    getGroupsForDropdown,
    getOperationEntityForDropdown,
    getCollectionPointForDropDown,
    getEmployeeForDropDown,
    getEmployeeTaskFilterData
    
};

async function getGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getOperationEntityForDropdown(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID='+id)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function getCollectionPointForDropDown(data) {
    var employeeModel = {
        groupID: data.groupID,
        operationEntityID: data.operationEntityID, 
        collectionCategoryID:'',
    }
    const response = await CommonPost('/api/CollectionPoint/GetCollectionPointByOperationEntityId', null, employeeModel);
    let collectionPointArray = []
   for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    
    return collectionPointArray;
}

async function getEmployeeForDropDown(collectionPointID) {
   const response = await CommonGet('/api/EmployeeTask/FilterEmployee','collectionPointID='+collectionPointID);
   let employeesArray=[]
    for (let item of Object.entries(response.data)) {
         employeesArray[item[1]["employeeID"]] = item[1]["firstName"]
        
    }
    
    return employeesArray;
}

async function getEmployeeTaskFilterData(data) {
    var employeeFilterModel = {
        groupID: (data.groupID),
        operationEntityID: (data.operationEntityID),
        collectionPointID: (data.collectionPointID),
        createdDate: (data.date),
        employeeID: (data.employeeID),
    }
    const response = await CommonPost('/api/EmployeeTask/FilterEmployeeTask', null, employeeFilterModel);
    return response.data;
}





